export default __webpack_public_path__ + "static/media/Large-Bread-2.a7b7000a.jpg";